
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
export default {
components:{
XHeader,
Toast
},
data(){
return{
show:false,
msg:"",

}
},
computed:{
...mapState(['token','userdetail'])
},
created(){
this.SETTOKEN();

},
methods:{
...mapMutations(['SETTOKEN','INITUSERDETAIL']),
toPath(url) {
navigator.clipboard.writeText(url).then(() => {
this.sendMsg(this.$t('复制成功'));
})

return
const a = document.createElement('a');
a.href = url;
a.target = "_bank";
document.body.append(a);
a.click();
document.body.removeChild(a)

},
sendMsg(content) {
this.msg = content;
this.show = true;
}
}
}



// WEBPACK FOOTER //
// ./src/pages/rechargeType.vue